import { Log } from '@/parsing/Log';
import { LogEntryType } from '@/parsing/LogEntry';

import { TimelineMarker, TimelineRow, TimelineRowGroup } from '../../TimelineData';
import { obtainFreeRowForMarker } from '../obtainFreeRowForMarker';
import { TimelineGeneratorContext } from '../TimelineGeneratorContext';
import { IosRouterTimelineMarker, IosRouterTreeBuilder } from './IosRouterTree';

export function generateIosRouterGroupFromLog(
  log: Log,
  ctx: TimelineGeneratorContext,
): TimelineRowGroup {
  const rows: TimelineRow[] = [];
  const routerTreeBuilder = new IosRouterTreeBuilder();

  for (const entry of log.entries) {
    if (entry.entryType !== LogEntryType.Generic) {
      continue;
    }
    if (entry.extra.generic?.module !== 'RIDERCORE.ROUTER') {
      continue;
    }

    const tooltipContent = entry.content;
    const routerTreeSnapshot = routerTreeBuilder.apply(entry.content);
    let textOnMarker = entry.content;

    const isAttaching = tooltipContent.startsWith('Attaching');
    if (isAttaching) {
      textOnMarker = textOnMarker.replace('Attaching ', '');
      textOnMarker = textOnMarker.replace(' to ', ' 🔗 ');
    } else {
      textOnMarker = textOnMarker.replace('Detaching ', '');
      textOnMarker = textOnMarker.replace(' from ', ' ✄ ');
    }

    const marker: TimelineMarker = {
      markerId: ctx.nextMarkerId,
      logEntry: entry,
      startTimeMs: entry.date.getTime(),
      endTimeMs: undefined,
      fillColor: isAttaching ? '#99fcd6' : '#ccb19d',
      textOnMarker,
      textOnMarkerColor: isAttaching ? '#338a63' : '#874b63',
      tooltipContent,
    };
    if (routerTreeSnapshot) {
      (marker as IosRouterTimelineMarker).iosRouterTreeSnapshot = routerTreeSnapshot;
    }
    ctx.nextMarkerId += 1;

    const row = obtainFreeRowForMarker(rows, marker);
    row.markers.push(marker);
  }

  const rowGroup: TimelineRowGroup = {
    name: 'Router',
    rows,
    expanded: true,
  };
  return rowGroup;
}
